module.exports = __webpack_public_path__ + "static/purple-cow-new-edition-66053afd9643368e42010f1b7672d573.jpg";